import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBusinessHighlights } from '../../Apis/content';

export const BusinessHighlights = createAsyncThunk('businesshighlights', async (formData, { rejectWithValue }) => {
    try {
        const response = await getBusinessHighlights(formData);
        return response?.data?.data;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const businessSlice = createSlice({
    name: 'businesshighlights',
    initialState: {
        error: null,
        success: false,
        data: [],
        Single: [],
        tags: [],
        addOn: []
    },
    reducers: {
        clearBusinessStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(BusinessHighlights.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(BusinessHighlights.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                // state.data = action.payload.data.data;
                state.data = action.payload;
            })
            .addCase(BusinessHighlights.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearBusinessStatus } = businessSlice.actions;
export default businessSlice.reducer;

